module.exports = __webpack_public_path__ + "static/media/price.b8a8c59e.png";